import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { createGoodsReceiptSearchSchema } from "@/screens/WarehouseReceiving/schemas"
import { SoftReceivedGoodsReceiptsContainer } from "@/screens/WarehouseReceiving/subfeatures/SoftReceived/components"

export const Route = createFileRoute("/app/warehouse-receiving/_layout/soft-received")({
  validateSearch: zodValidator(createGoodsReceiptSearchSchema(GoodsReceiptSortField.SoftReceivedOn, SortingOrder.Desc)),
  component: () => <SoftReceivedGoodsReceiptsContainer />,
})
